import { SET_LEADS_META } from '../actions';

const initialState = {
  currentPage: 1,
  pageSize: 12,
  totalCount: 0,
  totalPages: 0,
  loaded: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
  case SET_LEADS_META:
    return { ...state, ...(action.payload || {}), loaded: true };
  default:
    return state;
  }
}
